import accessStore from '../../../services/locations/AccessStore'
(function () {
    'use strict';

    angular.module('clientDashboardApp.admin.groups.groupsService', []).service('groupsService', GroupsService);

    GroupsService.$inject = ['$http','$cacheFactory','cacheService'];
    function GroupsService($http, $cacheFactory, cacheService) {
        this.http_ = $http;
        this.cache = $cacheFactory.get('apiCache');
        this.cs_ = cacheService;
    }

    GroupsService.prototype.listGroups = function (accountId, query) {
        var params = {};
        if (accountId)
            params.accountId = accountId;
        if (query) {
            params.groupQuery = query;
        }
        var url = '/v5/groups';
        var cacheKey = this.cs_.generateCacheKey(accountId, query);
        return this.cs_.cachedGetRequest(url,{params: params},'group',cacheKey);
    };

    GroupsService.prototype.exportGroups = function (accountId, groupSearchQuery) {
      var params = {accountId: accountId};

      if(groupSearchQuery){
        params.groupQuery = groupSearchQuery;
      }
      return this.http_.get('/v5/export/groups', {params: params});
    };

    GroupsService.prototype.exportGroupLocations = function (groupId) {
      return this.http_.get('/v5/export/groups/' + groupId + "/locations");
    };

    GroupsService.prototype.listGroupLocations = function (groupId, query) {
        var params = {};
        if (query) {
            params.locationsQuery = query;
        }
        var url = '/v5/groups/' + groupId + '/locations';
        var cacheKey = this.cs_.generateCacheKey(groupId, query);
        return this.cs_.cachedGetRequest(url,{params: params},'groupLocation',cacheKey);
    };

    GroupsService.prototype.getGroup = function (groupId) {
      return this.http_.get('/v5/group/' + groupId);
    };

    GroupsService.prototype.createGroup = function (accountId, groupName) {
        return this.http_.post('/v5/groups', {accountId: accountId, groupName: groupName}).then(x => {
          accessStore.invalidate()
          return x
        });
    };

    GroupsService.prototype.updateGroup = function (group) {
        return this.http_.put('/v5/groups/' + group.id, group).then(x => {
          accessStore.invalidate()
          return x
        });
    };

    GroupsService.prototype.addLocationsToGroup = function (groupId, locationIds) {
        return this.http_.post('/v5/groups/' + groupId + '/locations', {locationIds: locationIds}).then(x => {
          accessStore.invalidate()
          return x
        });
    };

  GroupsService.prototype.removeLocationsFromGroup = function (groupId, locationIds) {
    var locIdStr = "";
    _.each(locationIds,function(item,index){
      var separator = index == 0 ? "" : ",";
      locIdStr += separator+item;
    })
    var params = {
      locationIds: locIdStr
    }
    return this.http_.delete('/v5/groups/' + groupId + '/locations', {params: params});
  };

  GroupsService.prototype.deleteGroup = function (group) {
    return this.http_.delete('/v5/groups/' + group.id);
  };

})();
